import App from './App.svelte';
import './global.css'
import WearTestingRouter from './router/WearTestingRouter.svelte';

new WearTestingRouter({
  target: document.querySelector('#nikecraft-container'),
});
